import React from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';
import Progress from '../elements/Progress';
import { formatBytes, isNullOrUndefined } from '../../utils/siteFunctions';

const UploadProgress = ({uploadingFiles, showType = false}) => {
	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: `max-content auto max-content max-content max-content${showType ? ' max-content' : ''}`,
				columnGap: '2em',
				rowGap: '1.5em'
			}}
		>
			{uploadingFiles.slice(0).reverse().map((x, index) => (
				<React.Fragment key={index}>
					<div>Progress: </div>
					<div>
						<Progress
							value={x.progress}
							total={x.file.size}
							progress="percent"
							precision={0}
							secondary={isNullOrUndefined(x.error)}
							error={!isNullOrUndefined(x.error)}
							active={x.progress < x.file.size}
						>
							{!isNullOrUndefined(x.error) ? 'Error' : x.progress < x.file.size ? 'Uploading...' : 'Completed'}
						</Progress>
					</div>
					<div>{x.file.name}</div>
					{ showType && <div>{x.type}</div> }
					<div>{dayjs(x.file.lastModified).format('M/D/YYYY')}</div>
					<div>{formatBytes(x.file.size)}</div>
				</React.Fragment>
			))}
		</div>
	);
};

export interface FileWithID {
	id: string;
	file: File;
	type?: string;
	progress: number;
	error?: string;
	completed: boolean;
}

export interface UploadProgressProps {
	uploadingFiles: FileWithID[];
	showType?: boolean;
}

export default UploadProgress;